import instance from "@/utils/require.js"

// 型号管理--产品分页查询
export function apiProductSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/product/search",
		method: "post",
		data
	})
}

// 型号管理--新增型号
export function apiProductAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/product/add",
		method: "post",
		data
	})
}

export function apiMacSupportType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/mac_support_type",
		method: "post",
		data
	})
}

// 型号管理--产测工具列表
export function apiSupportType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/support_type",
		method: "post",
		data
	})
}
export function apiFactoryToolsList(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/list",
		method: "post",
		data
	})
}

// 型号管理--产品类别列表
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 型号管理--Key类型下拉
export function apiP2PType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/p2p_type",
		method: "post",
		data
	})
}

export function apiNetIdItemCodeList(data = {}) {
	return instance({
		url: "/aim/api/v3/item_code/net_id",
		method: "post",
		data
	})
}

// 型号管理--产品型号详情
export function apiProductDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/product/detail",
		method: "post",
		data
	})
}

// 型号管理--修改型号
export function apiProductUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/product/update",
		method: "post",
		data
	})
}

// 型号管理--修改配置信息
export function apiProductUpdateConfig(data = {}) {
	return instance({
		url: "/aim/api/v3/product/update_config",
		method: "post",
		data
	})
}

// 型号管理--锁定工序
export function apiProductLockSop(data = {}) {
	return instance({
		url: "/aim/api/v3/product/lock_sop",
		method: "post",
		data
	})
}

// 型号管理--解锁工序
export function apiProductUnlockSop(data = {}) {
	return instance({
		url: "/aim/api/v3/product/unlock_sop",
		method: "post",
		data
	})
}

// 生产工序--生产线
export function apiProductionLine(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/organization_type/production_line",
		method: "post",
		data
	})
}

// 生产工序--表格Sop
export function apiProductSopSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/search",
		method: "post",
		data
	})
}

// 生产工序--新增sop
export function apiProductSopAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/add",
		method: "post",
		data
	})
}

// 生产工序--修改sop
export function apiProductSopUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/update",
		method: "post",
		data
	})
}

// 生产工序--禁用sop
export function apiProductSopDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/disable",
		method: "post",
		data
	})
}

// 生产工序--启用sop
export function apiProductSopEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/enable",
		method: "post",
		data
	})
}

// 生产工序--删除sop
export function apiProductSopDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/delete",
		method: "post",
		data
	})
}

// 生产工序--下移sop
export function apiProductSopMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/move_down",
		method: "post",
		data
	})
}

// 生产工序--上移sop
export function apiProductSopMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/move_up",
		method: "post",
		data
	})
}

// 生产工序--工序下拉
export function apiWorkStationList(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/list",
		method: "post",
		data
	})
}

// 生产工序--上一工序下拉
export function apiProductSopList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/sop/list",
		method: "post",
		data
	})
}